import fetcher from '@/core/lib/fetcher'
import { APIResponse } from '@/core/types/utils'
import { queryOptions } from '@tanstack/react-query'
import { ServiceBlock } from './serviceBlocks.types'

export const getServiceBlocks = (siteId: string, token: string) =>
  queryOptions({
    queryKey: ['serviceBlocks', siteId, token],
    queryFn: () =>
      fetcher
        .auth(`Bearer ${token}`)
        .get(
          import.meta.env.VITE_API_BOOKING + `property/${siteId}/resourceBlocks`
        )
        .json<Promise<APIResponse<ServiceBlock[]>>>(),
  })
